/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type CartV2AddInput = {
    readonly id: string;
    readonly quantity?: number | null;
    readonly cartItems?: ReadonlyArray<string | null> | null;
    readonly productApiId?: string | null;
    readonly conciergeCustomerAccountId?: string | null;
    readonly clientMutationId?: string | null;
};
export type CartV2AddMutationVariables = {
    readonly input: CartV2AddInput;
};
export type CartV2AddMutationResponse = {
    readonly cartV2Add: ({
        readonly cartV2: ({
            readonly id: string;
            readonly cartId: string | null;
            readonly autoShipEnabled: boolean | null;
            readonly autoShipIntervalUnit: string | null;
            readonly autoShipIntervalCount: number | null;
            readonly promoCodeSavings: number | null;
            readonly saleSavings: number | null;
            readonly canSubscribeForAutoShip: boolean | null;
            readonly discountQualifiedCartTotal: number | null;
            readonly subTotalPriceOfItems: number | null;
            readonly subTotalPriceOfItemsWithDiscount: number | null;
            readonly total: number | null;
            readonly totalSavings: number | null;
            readonly totalNumberOfItems: number | null;
            readonly eventId: string | null;
            readonly eventHostFirstName: string | null;
            readonly event: ({
                readonly id: string;
                readonly eventId: string | null;
                readonly trinityPartyType: string | null;
            }) | null;
            readonly promoCodes: ReadonlyArray<({
                readonly id: string;
                readonly code: string | null;
                readonly promoDescription: string | null;
                readonly thresholds: ReadonlyArray<({
                    readonly discountAmount: string | null;
                    readonly discountAmountEach: string | null;
                }) | null> | null;
            }) | null> | null;
            readonly wordPressCoupons: ReadonlyArray<({
                readonly code: string | null;
                readonly couponDescription: string | null;
                readonly storeBalance: number | null;
                readonly yotpoCouponCode: string | null;
            }) | null> | null;
            readonly wordPressCouponSavings: ReadonlyArray<number | null> | null;
            readonly entries: ({
                readonly edges: ReadonlyArray<({
                    readonly node: ({
                        readonly id: string;
                        readonly sku: string | null;
                        readonly productId: string | null;
                        readonly quantity: number | null;
                        readonly productName: string | null;
                        readonly productURLslug: string | null;
                        readonly productImageUrl: string | null;
                        readonly wineBottleQuantity: number | null;
                        readonly isWinePack: boolean | null;
                        readonly priceOriginal: number | null;
                        readonly priceSale: number | null;
                        readonly priceDiscount: number | null;
                        readonly discountEligible: boolean | null;
                        readonly priceDiscountPercent: number | null;
                        readonly hasQualifyingDiscount: boolean | null;
                    }) | null;
                }) | null> | null;
            }) | null;
        }) | null;
    }) | null;
};
export type CartV2AddMutation = {
    readonly response: CartV2AddMutationResponse;
    readonly variables: CartV2AddMutationVariables;
};



/*
mutation CartV2AddMutation(
  $input: CartV2AddInput!
) {
  cartV2Add(input: $input) {
    cartV2 {
      id
      cartId
      autoShipEnabled
      autoShipIntervalUnit
      autoShipIntervalCount
      promoCodeSavings
      saleSavings
      canSubscribeForAutoShip
      discountQualifiedCartTotal
      subTotalPriceOfItems
      subTotalPriceOfItemsWithDiscount
      total
      totalSavings
      totalNumberOfItems
      eventId
      eventHostFirstName
      event {
        id
        eventId
        trinityPartyType
      }
      promoCodes {
        id
        code
        promoDescription
        thresholds {
          discountAmount
          discountAmountEach
        }
      }
      wordPressCoupons {
        code
        couponDescription
        storeBalance
        yotpoCouponCode
        id
      }
      wordPressCouponSavings
      entries(first: 1000) {
        edges {
          node {
            id
            sku
            productId
            quantity
            productName
            productURLslug
            productImageUrl
            wineBottleQuantity
            isWinePack
            priceOriginal
            priceSale
            priceDiscount
            discountEligible
            priceDiscountPercent
            hasQualifyingDiscount
          }
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "CartV2AddInput!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "CartV2AddInput!"
        } as any)
    ], v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "subTotalPriceOfItemsWithDiscount",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "autoShipEnabled",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "autoShipIntervalUnit",
        "args": null,
        "storageKey": null
    } as any), v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "autoShipIntervalCount",
        "args": null,
        "storageKey": null
    } as any), v7 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "promoCodeSavings",
        "args": null,
        "storageKey": null
    } as any), v8 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "saleSavings",
        "args": null,
        "storageKey": null
    } as any), v9 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "canSubscribeForAutoShip",
        "args": null,
        "storageKey": null
    } as any), v10 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "discountQualifiedCartTotal",
        "args": null,
        "storageKey": null
    } as any), v11 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "subTotalPriceOfItems",
        "args": null,
        "storageKey": null
    } as any), v12 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "cartId",
        "args": null,
        "storageKey": null
    } as any), v13 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "total",
        "args": null,
        "storageKey": null
    } as any), v14 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "totalSavings",
        "args": null,
        "storageKey": null
    } as any), v15 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "totalNumberOfItems",
        "args": null,
        "storageKey": null
    } as any), v16 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "eventId",
        "args": null,
        "storageKey": null
    } as any), v17 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "eventHostFirstName",
        "args": null,
        "storageKey": null
    } as any), v18 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "event",
        "storageKey": null,
        "args": null,
        "concreteType": "Event",
        "plural": false,
        "selections": [
            (v3 /*: any*/),
            (v16 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "trinityPartyType",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v19 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "code",
        "args": null,
        "storageKey": null
    } as any), v20 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "promoCodes",
        "storageKey": null,
        "args": null,
        "concreteType": "PromoCode",
        "plural": true,
        "selections": [
            (v3 /*: any*/),
            (v19 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "promoDescription",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "thresholds",
                "storageKey": null,
                "args": null,
                "concreteType": "PromoCodeThresholds",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "discountAmount",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "discountAmountEach",
                        "args": null,
                        "storageKey": null
                    }
                ]
            }
        ]
    } as any), v21 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "couponDescription",
        "args": null,
        "storageKey": null
    } as any), v22 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "storeBalance",
        "args": null,
        "storageKey": null
    } as any), v23 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "yotpoCouponCode",
        "args": null,
        "storageKey": null
    } as any), v24 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "wordPressCouponSavings",
        "args": null,
        "storageKey": null
    } as any), v25 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "entries",
        "storageKey": "entries(first:1000)",
        "args": [
            {
                "kind": "Literal",
                "name": "first",
                "value": 1000,
                "type": "Int"
            }
        ],
        "concreteType": "CartEntryV3Connection",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CartEntryV3Edge",
                "plural": true,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CartEntryV3",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "wineBottleQuantity",
                                "args": null,
                                "storageKey": null
                            },
                            (v3 /*: any*/),
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "productId",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "quantity",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "productName",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "productURLslug",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "productImageUrl",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "sku",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "isWinePack",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "priceOriginal",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "priceSale",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "priceDiscount",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "discountEligible",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "priceDiscountPercent",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "hasQualifyingDiscount",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    }
                ]
            }
        ]
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "CartV2AddMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "cartV2Add",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "CartV2AddPayload",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "cartV2",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CartV2",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                (v5 /*: any*/),
                                (v6 /*: any*/),
                                (v7 /*: any*/),
                                (v8 /*: any*/),
                                (v9 /*: any*/),
                                (v10 /*: any*/),
                                (v11 /*: any*/),
                                (v12 /*: any*/),
                                (v13 /*: any*/),
                                (v14 /*: any*/),
                                (v15 /*: any*/),
                                (v16 /*: any*/),
                                (v17 /*: any*/),
                                (v18 /*: any*/),
                                (v20 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "wordPressCoupons",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "WordPressCoupon",
                                    "plural": true,
                                    "selections": [
                                        (v19 /*: any*/),
                                        (v21 /*: any*/),
                                        (v22 /*: any*/),
                                        (v23 /*: any*/)
                                    ]
                                },
                                (v24 /*: any*/),
                                (v25 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "CartV2AddMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "cartV2Add",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "CartV2AddPayload",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "cartV2",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CartV2",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                (v5 /*: any*/),
                                (v6 /*: any*/),
                                (v7 /*: any*/),
                                (v8 /*: any*/),
                                (v9 /*: any*/),
                                (v10 /*: any*/),
                                (v11 /*: any*/),
                                (v12 /*: any*/),
                                (v13 /*: any*/),
                                (v14 /*: any*/),
                                (v15 /*: any*/),
                                (v16 /*: any*/),
                                (v17 /*: any*/),
                                (v18 /*: any*/),
                                (v20 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "wordPressCoupons",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "WordPressCoupon",
                                    "plural": true,
                                    "selections": [
                                        (v19 /*: any*/),
                                        (v21 /*: any*/),
                                        (v22 /*: any*/),
                                        (v23 /*: any*/),
                                        (v3 /*: any*/)
                                    ]
                                },
                                (v24 /*: any*/),
                                (v25 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "mutation",
            "name": "CartV2AddMutation",
            "id": null,
            "text": "mutation CartV2AddMutation(\n  $input: CartV2AddInput!\n) {\n  cartV2Add(input: $input) {\n    cartV2 {\n      id\n      cartId\n      autoShipEnabled\n      autoShipIntervalUnit\n      autoShipIntervalCount\n      promoCodeSavings\n      saleSavings\n      canSubscribeForAutoShip\n      discountQualifiedCartTotal\n      subTotalPriceOfItems\n      subTotalPriceOfItemsWithDiscount\n      total\n      totalSavings\n      totalNumberOfItems\n      eventId\n      eventHostFirstName\n      event {\n        id\n        eventId\n        trinityPartyType\n      }\n      promoCodes {\n        id\n        code\n        promoDescription\n        thresholds {\n          discountAmount\n          discountAmountEach\n        }\n      }\n      wordPressCoupons {\n        code\n        couponDescription\n        storeBalance\n        yotpoCouponCode\n        id\n      }\n      wordPressCouponSavings\n      entries(first: 1000) {\n        edges {\n          node {\n            id\n            sku\n            productId\n            quantity\n            productName\n            productURLslug\n            productImageUrl\n            wineBottleQuantity\n            isWinePack\n            priceOriginal\n            priceSale\n            priceDiscount\n            discountEligible\n            priceDiscountPercent\n            hasQualifyingDiscount\n          }\n        }\n      }\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '654d63f8025751fad809b542b31324eb';
export default node;
